module.exports = __webpack_public_path__ + "static/media/Inspiron6.18892606.png";